<div class="banner" role="banner">
  <h1>{{ 'gallery.page.title' | translate }}</h1>
</div>

<div class="pb-5"><fgb-worksheet-list></fgb-worksheet-list></div>
